import React from 'react';
import {
  Form,
  Button,
  TreeSelect,
  Popover,
  Row,
  Badge,
  notification,
} from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FilterOutlined } from '@ant-design/icons';

const WrapperButtons = styled(Row)`
  align-items: center;
  display: flex;
  justify-content: flex-end;

  button:first-child {
    margin-right: 16px;
  }
`;

const FormFilter = ({
  type,
  filterOptions = [],
  dvirFilterOptions = [],
  nextPMFilterOptions = [],
  onSubmit,
  onChangeFilter,
  onClear,
  popoverVisible,
  togglePopoverVisibility,
  countFiltersSelected,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (err) {
      notification.error({
        message: 'Error',
        key: 'error',
        description: `Validation failed:${err} `,
      });
    }
  };

  const clearData = () => {
    form.resetFields();
    onClear();
  };

  const formContent = (
    <Form form={form} style={{ width: '78vw' }} onFinish={handleSubmit}>
      {type === 'vehicles' && (
        <Form.Item label="Filter by Status" name="car_status">
          <TreeSelect
            treeData={filterOptions.map((item) => ({
              title: item.text,
              value: item.value,
            }))}
            allowClear
            onChange={(value) => onChangeFilter('car_status', value)}
            treeCheckable
            showCheckedStrategy={TreeSelect.SHOW_PARENT}
            placeholder="Please select status"
            style={{ width: '100%' }}
          />
        </Form.Item>
      )}

      <Form.Item label="Filter by DVIR" name="dvirStatus">
        <TreeSelect
          treeData={dvirFilterOptions.map((item) => ({
            title: item.text,
            value: item.value,
          }))}
          onChange={(value) => onChangeFilter('dvirStatus', value)}
          allowClear
          treeCheckable
          showCheckedStrategy={TreeSelect.SHOW_PARENT}
          placeholder="Please select DVIR"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item label="Filter by Next PM due" name="nextPmFilter">
        <TreeSelect
          treeData={nextPMFilterOptions.map((item) => ({
            title: item.text,
            value: item.value,
          }))}
          onChange={(value) => onChangeFilter('nextPmFilter', value)}
          allowClear
          treeCheckable
          showCheckedStrategy={TreeSelect.SHOW_PARENT}
          placeholder="Please select Next PM due"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item>
        <WrapperButtons>
          <Button type="default" onClick={clearData}>
            Clear
          </Button>
          <Button type="primary" htmlType="submit">
            Ok
          </Button>
        </WrapperButtons>
      </Form.Item>
    </Form>
  );

  return (
    <Popover
      placement="bottomLeft"
      open={popoverVisible}
      onOpenChange={togglePopoverVisibility}
      content={formContent}
      title="Filters"
      trigger="click"
    >
      <Button type="primary" icon={<FilterOutlined />} block>
        Filters{' '}
        {countFiltersSelected > 0 && (
          <Badge
            count={countFiltersSelected >= 10 ? '9+' : countFiltersSelected}
            style={{
              marginLeft: 5,
              backgroundColor: '#fff',
              color: '#123FBF',
            }}
          />
        )}
      </Button>
    </Popover>
  );
};

FormFilter.propTypes = {
  type: PropTypes.string,
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any,
    })
  ),
  dvirFilterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any,
    })
  ),
  nextPMFilterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any,
    })
  ),
  onSubmit: PropTypes.func.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  popoverVisible: PropTypes.bool.isRequired,
  togglePopoverVisibility: PropTypes.func.isRequired,
  countFiltersSelected: PropTypes.number.isRequired,
};

export default FormFilter;
